/**
 * Created by - Ashlekh
 * Reason - To add About Us
 */

import { useEffect, useState, useContext } from "react";
import style from "./AboutUs.module.css";
import parse from "html-react-parser";
import { GlobalContext } from "../../context/Context";
import { getAboutUsDetailsApi, homepage } from "../../Api/services";
// import config from "../../Api/config";
import NavigationPath from "../../components/NavigationPath/NavigationPath";
import config, { baseURL } from "../../Api/config";

const AboutUs = () => {
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);
  const [showContent, setShowContent] = useState(false);
  // Added by - Ashlekh on 26-04-2025
  // Reason - To set page content
  const [pageContent, setPageContent] = useState({});
  // End of code - Ashlekh on 26-04-2025
  // Reason - To set page content
  // Added by - Ashlekh on 26-04-2025
  // Reason - This useEffect will execute when page loads
  // Added by - Yogen on 16-06-2025
  // Reason - UseState to store mission and vision section
  const [homePagePurpose, setHomePagePurpose] = useState([]);
  // End of code - Yogen on 16-06-2025
  // Reason - UseState to store mission and vision section
  useEffect(() => {
    setNavigationPath([
      { name: "Home", path: "/" },
      { name: "About Us", path: "/about_us" },
    ]);
    window.scrollTo(0, 0);
    aboutUsDetails();
  }, []);
  // End of code - Ashlekh on 26-04-2025
  // Reason - This useEffect will executes when page loads

  // Added by - Ashlekh on 26-04-2025
  // Reason - To get details from backend
  const aboutUsDetails = async () => {
    try {
      const response = await getAboutUsDetailsApi();
      setPageContent(response?.about_us_details);
      // Added by - Yogen on 16-06-2025
      // Reason - To set mission and vision details in useState
      setHomePagePurpose(response?.home_page_purpose);
      // End of code - Yogen on 16-06-2025
      // Reason - To set mission and vision details in useState
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setShowContent(true);
    }
  };
  // End of code - Ashlekh on 26-04-2025
  // Reason - To get details from backend
  return (
    <div>
      {showContent ? (
        <div className={`${style.mainContainer}`}>
          {pageContent?.banner_image ? (
            <div className={`${style.bannerImage}`}>
              <img
                className={`${style.image}`}
                src={config.baseURL + pageContent?.banner_image}
                alt=""
              />
            </div>
          ) : null}

          <NavigationPath navigationPathArray={navigationPath} />
          {pageContent?.description || pageContent?.description?.length > 0 ? (
            <div className={`${style.pageTitle}`}>About Us</div>
          ) : (
            <p className={style.noDetailsAvailableText}>No details available</p>
          )}
          {pageContent?.description ? (
            <div className={`${style.description}`}>
              {" "}
              {parse(pageContent?.description)}{" "}
            </div>
          ) : null}
        </div>
      ) : (
        <div className={style.loaderContent}>
          <img style={{ height: "30vh" }} src="/adyant_loader.gif" />
        </div>
      )}
      {/* Added by - Yogen on 16-06-2025
          Reason - To display Mission And Vision */}
      {homePagePurpose?.length > 0 && (
      <div className={`${style.missionVisionTitle}`}> Mission And Vision </div>
       )} 
      <div className={`${style.homePagePurposeContainer}`}>
        {homePagePurpose?.map((item, index) => (
        <div
          key={index}
          className={`${style.homePagePurposeSubContainer}`}
        >
          <div
            className={`${style.homePagePurposeBackgroundImageContainer}`}
            style={{
              backgroundImage:
                "url(" + baseURL + item.background_image + ")",
            }}
          >
            <div className={`${style.homePagePurposeTitle}`}>
              {item?.title}
            </div>
          </div>
          <div className={`${style.homePagePurposeIconContainer}`}>
            <img
              src={`${config.baseURL + item?.icon}`}
              className={`${style.homePagePurposeIcon}`}
            />
          </div>
          <div className={`${style.homePagePurposeDescription}`}>
            {item.description}
          </div>
        </div>
         ))} 
      </div>
      {/* End of code - Yogen on 16-06-2025
          Reason - To display Mission And Vision */}
    </div>
  );
};
export default AboutUs;
